import { useFormContext } from 'react-hook-form';
import { emailPatternRule, maxLengthRule, requiredText, trimString } from '#/Scripts/shared/form/validation';
import { isValidPhoneNumber } from '#/Scripts/utilities/PhoneNumber';
import FormTextField from '#sign-up/components/common/FormTextField/FormTextField';
import { SignupFormValues } from '#sign-up/components/SignUp/types';

export const ContactInformationForm = () => {
  const form = useFormContext<SignupFormValues>();
  return (
    <div className="signup-form contact-information">
      <div className="signup-form-header">
        <h1>Main Contact Information</h1>
        <p>
          This person will be the primary administrator managing the ePayPolicy account day-to-day and our main point of
          contact for inquiries.
        </p>
      </div>
      <div className="signup-form-row">
        <FormTextField
          label="First Name"
          {...form.register('FirstName', {
            ...requiredText('First Name'),
            ...maxLengthRule(40, 'First Name'),
            ...trimString,
          })}
          errors={form.formState.errors.FirstName}
          className="with-subtext"
          autoComplete="given-name"
        />
        <FormTextField
          label="Last Name"
          {...form.register('LastName', {
            ...requiredText('Last Name'),
            ...maxLengthRule(40, 'Last Name'),
            ...trimString,
          })}
          errors={form.formState.errors.LastName}
          className="with-subtext"
          autoComplete="family-name"
        />
      </div>
      <div className="signup-form-row">
        <FormTextField
          label="Email Address"
          {...form.register('EmailAddress', {
            ...requiredText('Email Address'),
            ...emailPatternRule('Email Address'),
            ...trimString,
          })}
          errors={form.formState.errors.EmailAddress}
          className="with-subtext"
        />
        <FormTextField
          label="Phone Number"
          {...form.register('PhoneNumber', {
            ...requiredText('Phone Number'),
            validate: {
              isValidPhoneNumber: (value) => (value && isValidPhoneNumber(value)) || 'Phone Number is invalid.',
            },
            ...trimString,
          })}
          errors={form.formState.errors.PhoneNumber}
          className="with-subtext"
        />
      </div>
    </div>
  );
};
